import { webToCatchFaceConnect } from '../lace/webToCatchFaceConnect'
import { webTops } from 'src/features/brands/treasure/canvas/glove/back/lace/webTop'
import {
  connectWebToIndex,
  connectWebToIndexTop,
  connectWebToThumb,
  connectWebToThumbTop
} from 'src/features/brands/treasure/canvas/glove/back/lace/connectWebAndFinger'
import { webKnots } from '../../../common/back/lace/webKnots'

export const wt11Web = (ctx: CanvasRenderingContext2D, webColor: string, laceColor: string, stitchColor: string): void => {
  ctx.lineWidth = 0.8
  ctx.strokeStyle = '#282828'
  ctx.fillStyle = webColor
  // ウェブパーツ横_上部
  ctx.beginPath()
  ctx.moveTo(576, 44) // 左上
  ctx.quadraticCurveTo(546, 91, 546, 91) // 左下
  ctx.quadraticCurveTo(618, 148, 685, 277) //右下
  ctx.quadraticCurveTo(708, 253, 721, 245) //右上
  ctx.quadraticCurveTo(625, 70, 576, 44) //左上
  ctx.fill()
  ctx.stroke()
  ctx.closePath()

  // ウェブパーツ横_中・下部
  ctx.beginPath()
  ctx.moveTo(546, 91) // 左上
  ctx.quadraticCurveTo(576, 151, 576, 151) // 中央＿左
  ctx.quadraticCurveTo(527, 138, 527, 138) // 左下＿上
  ctx.quadraticCurveTo(498, 212, 498, 212) // 左下＿下
  ctx.quadraticCurveTo(568, 275, 615, 342) // 右下＿下
  ctx.quadraticCurveTo(641, 326, 660, 312) // 右下＿上
  ctx.quadraticCurveTo(651, 243, 651, 243) // 中央＿右
  ctx.quadraticCurveTo(684, 275, 684, 275) // 右上＿下
  ctx.quadraticCurveTo(632, 167, 546, 91) // 左上
  ctx.fill()
  ctx.stroke()
  ctx.closePath()

  // stitchここから
  ctx.beginPath()
  ctx.strokeStyle = stitchColor
  ctx.setLineDash([3, 3])
  // 横向き＿上
  ctx.moveTo(572, 60) // 左上
  ctx.quadraticCurveTo(659, 147, 708, 251) // 右下
  ctx.moveTo(570, 64) // 左上
  ctx.quadraticCurveTo(657, 151, 706, 255) // 右下
  // 中間の四角＿上辺
  ctx.moveTo(552, 87) // 左上
  ctx.quadraticCurveTo(636, 163, 689, 270) // 左下
  ctx.moveTo(550, 89) // 左上
  ctx.quadraticCurveTo(633, 165, 686, 272) // 左下
  // // 中間の四角＿左辺
  ctx.moveTo(551, 97) // 左上
  ctx.quadraticCurveTo(580, 148, 580, 155) // 中央＿左
  ctx.quadraticCurveTo(528, 141, 528, 141) // 左下＿上
  ctx.moveTo(557, 102) // 左上
  ctx.quadraticCurveTo(575, 127, 585, 159) // 中央＿左
  ctx.quadraticCurveTo(561, 155, 532, 147) // 左下
  // 中間の四角＿下辺
  ctx.moveTo(531, 145) // 左上
  ctx.quadraticCurveTo(654, 305, 654, 303) // 右下
  ctx.moveTo(527, 147) // 左上
  ctx.quadraticCurveTo(656, 311, 656, 311) // 右下
  // 中間の四角＿右辺
  ctx.moveTo(678, 263) // 左上＿下
  ctx.quadraticCurveTo(647, 235, 647, 235) // 中央＿右
  ctx.quadraticCurveTo(655, 307, 655, 307) // 右下＿上
  ctx.moveTo(669, 248) // 左上
  ctx.quadraticCurveTo(645, 229, 643, 229) // 中央＿右
  ctx.quadraticCurveTo(650, 298, 650, 298) // 右下＿上

  // 横向き＿下＿下
  ctx.moveTo(517, 177) // 左上
  ctx.quadraticCurveTo(639, 319, 639, 319) // 右下
  ctx.moveTo(515, 181) // 左上
  ctx.quadraticCurveTo(635, 320, 635, 320) // 右下
  ctx.stroke()
  ctx.setLineDash([])
  ctx.strokeStyle = '#282828'
  ctx.closePath()
  // stitchここまで

  // laceここから

  webToCatchFaceConnect(ctx, laceColor, -35, 17)
  webTops(ctx, laceColor, 20, 82) // 右＿親指から1番目
  webTops(ctx, laceColor, 15, 70) // 右＿親指から2番目
  webTops(ctx, laceColor, 5, 51) // 右＿親指から3番目
  webTops(ctx, laceColor, -7, 30) // 右＿親指から4番目
  webTops(ctx, laceColor, -20, 10) // 右＿親指から5番目
  webTops(ctx, laceColor, -33, -10) // 右＿親指から6番目
  webTops(ctx, laceColor, -45, -29) // 右＿親指から7番目
  webTops(ctx, laceColor, -58, -47) // 右＿親指から8番目
  webTops(ctx, laceColor, -70, -63) // 右＿親指から8番目
  webTops(ctx, laceColor, -85, -80) // 右＿親指から8番目
  webTops(ctx, laceColor, -100, -95) // 右＿親指から8番目

  connectWebToIndexTop(ctx, laceColor, 0, 0)
  connectWebToIndex(ctx, laceColor, 45, -92) //
  connectWebToIndex(ctx, laceColor, 10, -15) //
  connectWebToIndex(ctx, laceColor, -12, 38) //
  connectWebToThumbTop(ctx, laceColor, 0, 0)
  connectWebToThumbTop(ctx, laceColor, -10, 10)
  connectWebToThumb(ctx, laceColor, 60, 30) //
  connectWebToThumb(ctx, laceColor, 20, -25) //
  connectWebToThumb(ctx, laceColor, -12, -3) //
  webKnots(ctx, laceColor, 0, -35) // 捕球面寄りのウェブ結び目
  webKnots(ctx, laceColor, -50, 50) // 捕球面寄りのウェブ結び目
}
